/**
 * useMultiTermSearch hook (SBR-3529/3532 temporary mock)
 *
 * TEMPORARY MOCK - Returns hardcoded data for parallel development.
 *
 * IMPORTANT: Real GraphQL implementation will be added in SBR-3533.
 * Follow the pattern in getProductRecommendations.js:
 * - Use gqlClient from services/api/gql/gqlClient
 * - Import GraphQL query from constants/gql/queries/
 * - Add locale, Constructor.io client params (c, s, i)
 * - Handle authentication context (profileId, session)
 *
 * AC-027 validation happens in RelatedSearches component.
 */
import { useState, useEffect } from 'react';

/**
 * Mock hook for multiTermSearch GraphQL operation
 * @param {Object} options
 * @param {string[]} options.keywords - Array of search terms
 * @param {number} options.resultCount - Number of results per term (default: 4)
 * @returns {{data: Object|null, loading: boolean, error: Error|null}}
 */
function useMultiTermSearch({ keywords = [], resultCount = 4 }) {
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    useEffect(() => {
        // Don't fetch if no keywords
        if (!keywords || keywords.length === 0) {
            setData(null);
            setLoading(false);
            setError(null);

            return undefined;
        }

        setLoading(true);
        setError(null);

        // Simulate async fetch with setTimeout
        const timeoutId = setTimeout(() => {
            try {
                // Mock response matching MultiTermSearchResponse schema
                const mockResponse = {
                    results: keywords.map(term => ({
                        searchTerm: term,
                        thumbnailImages: Array(resultCount)
                            .fill(null)
                            .map((_, i) => ({
                                url: `https://www.sephora.com/productimages/sku/s${Math.floor(Math.random() * 1000000)}-main-zoom.jpg`,
                                altText: `${term} product ${i + 1}`
                            }))
                    }))
                };

                setData(mockResponse);
                setLoading(false);
            } catch (err) {
                setError(err);
                setLoading(false);
            }
        }, 100); // Simulate 100ms network delay

        return () => {
            clearTimeout(timeoutId);
        };
    }, [keywords.join('|'), resultCount]);

    return { data, loading, error };
}

export default useMultiTermSearch;
